import { createFileRoute } from '@tanstack/react-router';
import { PayrollLogicComponentDetailLayout } from './-components/PayrollLogicComponentDetailLayout';
export const Route = createFileRoute('/_staff/payroll-engine-mock/_layout/logic-components/$componentId/_layout')({
  component: PayrollLogicComponentDetailLayout
});